<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { createEventDispatcher, onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { openModal } from 'svelte-modals';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { jobs, planning } from '../../../stores/store';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import type { LocationResponseType } from './types';
    import { jobInitialData } from './jobInitialData';
    import JobEditForm from './JobEditForm.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import { LocationResponseSchema } from './types';
    import { Location } from './Location';
    import { MapPointLocation } from '../../utilities/MapPointLocation';
    import { onMapReady } from '../../utilities/onMapReady';
    import { JobOnMap } from './JobOnMap';
    import { api } from '../../../stores/api';
    import { LocationApi } from './LocationApi';
    import { BalloonContentGenerator } from '../../shared/BalloonContentGenerator';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { app } from '../../../stores/app';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ModalError from '../../shared/Modals/ModalError.svelte';

    let job: Location = new Location();
    let mapPointLocation: MapPointLocation | null = null;
    let dispatch = createEventDispatcher();
    let jobOnMap: JobOnMap = new JobOnMap();
    let jobGeocodedOnMap: JobOnMap = new JobOnMap();
    let triedToSave: boolean = false;

    let ready: boolean = false;
    let available: boolean = false;

    function prepareNewJob() {
        console.log('prepareNewJob()');
        let jobResponse: LocationResponseType = LocationResponseSchema.parse({
            ...jobInitialData(1, -2, 1),
            coords_accepted: false,
            ext_id: '',
            full_name: '',
            location_type: '',
            id: -1,
            newly_added: true,
            special_attributes: {
                ...jobInitialData(1, -2, 1).special_attributes,
            },
        });
        triedToSave = false;
        job.set(JSON.parse(JSON.stringify(jobResponse)));
        job.getData().id = -1;
        job = job;
    }

    function tryToUseRevGeoDetails(revGeoDetails) {
        if (jobOnMap) jobOnMap.clear();
        if (revGeoDetails) {
            job.updateAddressAttributeValue('pcode', revGeoDetails.postcode);
            job.updateAddressAttributeValue('city', revGeoDetails.city);
            job.updateAddressAttributeValue('country', revGeoDetails.country);
            job.updateAddressAttributeValue('street', revGeoDetails.street);
            job.updateAddressAttributeValue('house', revGeoDetails.house);
            job.updateAddressAttributeValue('province', revGeoDetails.province);
            job.updateAddressAttributeValue('quarter', revGeoDetails.quarter);
            job.updateAddressAttributeValue('community', revGeoDetails.community);

            job.setCoords(revGeoDetails.x, revGeoDetails.y, true);
            job.getData().address_id =
                revGeoDetails?.house_geoId && revGeoDetails?.house_geoId != ''
                    ? parseInt(revGeoDetails?.house_geoId)
                    : null;
            // job.getData().coords_accepted = true;
            let balloonHtml = new BalloonContentGenerator(job).getBalloonHtmlArray().join('');
            // jobOnMap.addPoint(revGeoDetails.x, revGeoDetails.y, '#334455', 'Adres');
            jobOnMap.addPoint(revGeoDetails.x, revGeoDetails.y, '#334455', balloonHtml);
            jobOnMap.centerMap();
            job = job;
        }
    }

    let startPointOnMap = function () {
        if (mapPointLocation) {
            if (!mapPointLocation.isCurrent()) {
                if (
                    mapPointLocation.start({
                        message: $_('Click on the map to set job #{count} coordinates', {
                            values: { count: job.id },
                        }),
                    })
                ) {
                    // dispatch('pointonmapstart');
                    console.log('pointonmapstart');
                }
            } else {
                mapPointLocation.close(true);
            }
        }
    };

    export const closePointOnMap = function () {
        if (mapPointLocation) {
            if (mapPointLocation.close(true)) {
                console.log('pointonmapclose');
            }
        }
    };

    async function onUpdate() {
        closePointOnMap();
        console.log('jobRequest, before parse', job);
    }

    onMount(() => {
        Promise.all([
            onMapReady(),
            LocationApi.getCountWithQueries($api, {}, new ApiFilterBuilder(-1))
        ]).then((response) => {
            if ($app.settingsReadonly?.allow_limit_exceeding || (response[1]?.count || 0) < ($app.settingsReadonly?.max_locations || 0)) {
                mapPointLocation = new MapPointLocation();
                mapPointLocation.addEventListener('setCoordinates', function (evt: any) {
                    let x = evt.detail.coords.x;
                    let y = evt.detail.coords.y;
                    let balloonHtml = '-Adres-';
                    console.log('setcoordinates', { type: 'Point', coordinates: [x, y] });
                    job.setCoords(x, y, true);
                    job = job;
                    LocationApi.revgeo($api, x, y)
                        .then(res => {
                            job.updateAddressAttributeValue('pcode', res.postcode);
                            job.updateAddressAttributeValue('city', res.city);
                            job.updateAddressAttributeValue('country', res.country);
                            job.updateAddressAttributeValue('street', res.street);
                            job.updateAddressAttributeValue('house', res.house);
                            job.updateAddressAttributeValue('province', res.province);
                            job.updateAddressAttributeValue('quarter', res.quarter);
                            job.updateAddressAttributeValue('community', res.community);
                            job.getData().address_id =
                                res?.house_geoId && res?.house_geoId != ''
                                    ? parseInt(res?.house_geoId)
                                    : null;
                            job = job;
                            balloonHtml = new BalloonContentGenerator(job)
                                .getBalloonHtmlArray()
                                .join('');
                            jobOnMap.addPoint(x, y, '#334455', balloonHtml);
                            jobOnMap.centerMap();
                        })
                        .catch(err => {
                            console.log('revgeo error', err);
                        });
                });
                mapPointLocation.addEventListener('close', function () {
                    dispatch('pointonmapclose');
                });
                available = true;
            } else {
                openModal(ModalError, {
                    header: $_('Error'),
                    message: $_('max_locations_exceeded_manual'),
                    onClick: () => {
                        window.history.back();
                    }
                });
            }
            ready = true;
        });

        return () => {
            if (mapPointLocation) mapPointLocation.close(true);
        };
    });

    prepareNewJob();
    tryToUseRevGeoDetails($jobs.revGeoDetails);
    $jobs.revGeoDetails = null;
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                <div style="display: flex; align-items: center;min-height: 36px;">
                    <IconBack
                        scale={0.7}
                        on:click={() => {
                            window.history.back();
                        }}
                    />
                    {$_('Manual add job')}
                </div>
            </div>
            <div slot="main-buttons" style="display:flex; align-items: center; column-gap: 25px;">
                <ButtonAddSomething
                    text={$_('Add job')}
                    on:click={() => {
                        prepareNewJob();
                    }}
                />
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <!--        <JobOneRow {job} {jobsOnMap} index={0} expandedIndex={0} switchable={false} fullEditableForm={true} />-->
        {#if ready}
            {#if available}
                <JobEditForm
                    bind:job
                    {startPointOnMap}
                    bind:jobOnMap
                    bind:jobGeocodedOnMap
                    bind:triedToSave
                />
            {/if}
        {:else}
            <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <Spinner/>
            </div>
        {/if}
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
</style>
